import Constant from '@/const';
import axios from 'axios';

const postPatientRegistration = async payload => {
  try {
    const response = await axios.post(
      Constant.apiUrl.concat('/patient/registration'),
      payload,
    );
    return response;
  } catch (error) {
    const err = error;
    throw err;
  }
};

export default postPatientRegistration;
